'use client';
import Hyperlink from '@/components/ui/hyperlink';
import { ExpertiseCreatorsServiceType, UseCaseStep } from '@/types/global';
import Image from 'next/image';

const Expertise = ({ title, description, data }: { title: string, description: string, data: ExpertiseCreatorsServiceType[] | UseCaseStep[] }) => {
    return (
        <section
            className={`desilo-service4-section overflow-hidden section-padding-top-bottom`}
            id="service-section"
        >
            <div className="container custom-container">
                <div className="row gx-4 gy-5">
                    <div className="col-md-10">
                        <div className="desilo__header row-padding-bottom text-start">
                            <h2 className="title">
                                {title}
                            </h2>
                            <p className="hero2-content-text">
                                {description}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        {/* service card start */}
                        {data?.map((item, i) => (
                            <div
                                key={i}
                                className="desilo-service-box4 fade-anim"
                            >
                                <h3 className="service-title">
                                    {item.title || ""}</h3>
                                <div className="service-info">
                                    <p>{item.description}</p>
                                    {item?.link && (
                                        <Hyperlink className='view-more' href={item.link}>View details</Hyperlink>
                                    )}
                                    <div className="blog-item">
                                        <div className="blog-tags mt-0">
                                            <ul className="custom-ul">
                                                {item?.tags?.map((tag, index) => (
                                                    <li key={index}>
                                                        <span className="service-tags">{tag}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                {item?.icon && (
                                    <div className="desilo-iconbox-icon">
                                        <Image
                                            height={52}
                                            width={52}
                                            src={item?.icon}
                                            alt="service-icon"
                                        />
                                    </div>
                                )}
                            </div>
                        ))}
                        {/* service card end */}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Expertise;
